import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Protección de Datos
          </h1>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-8">
            <p className="text-gray-800 font-semibold mb-2">TALLERES LUJAMBIO, S.L.</p>
            <p className="text-gray-700">B20700308</p>
            <p className="text-gray-700">Pol. Eziago 35, Parc 16 - 20120, Hernani (Gipuzkoa)</p>
            <p className="text-gray-700">943554787 - admin@tallereslujambio.com</p>
            <p className="text-gray-700">www.tallereslujambio.com</p>
          </div>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Protección de Datos Personales
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En esta web, propiedad de TALLERES LUJAMBIO, S.L., aseguramos la total protección de los datos de carácter personal proporcionados por nuestros usuarios.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              En esta sección ponemos a disposición del interesado la información legal o política de privacidad correspondiente a los distintos tratamientos de datos llevados a cabo por nuestra empresa.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En función de cuál sea su relación con nuestra empresa, le será aplicable la correspondiente política de privacidad:
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              CONTACTOS
            </h2>

            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Quién es el responsable de sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  De acuerdo con lo establecido por la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD) y el Reglamento General de Protección de Datos (RGPD) de 27 de Abril de 2016, le informamos que los datos personales aportados serán tratados por TALLERES LUJAMBIO, S.L. con CIF B20700308 y domicilio en Pol. Eziago 35, Parc 16 - 20120, Hernani (Gipuzkoa).
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Con qué finalidad tratamos sus datos personales?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Los datos aportados por usted son necesarios para poder prestarle con todas las garantías el servicio solicitado, y serán tratados con las siguientes finalidades: Gestión de los datos de contacto para la comunicación.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Por cuánto tiempo conservaremos sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Los datos personales proporcionados se conservarán mientras se prevea que pueden ser necesarios para contactar con el interesado.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Cuál es la legitimación para el tratamiento de sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  La base legal para el tratamiento de sus datos es el consentimiento del interesado al proporcionar sus datos de contacto.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿A qué destinatarios se comunicarán sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Sus datos no se cederán a terceros salvo obligación legal.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Cuáles son sus derechos cuando nos facilita sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Cualquier persona tiene derecho a solicitar el acceso, rectificación, supresión, limitación del tratamiento, oposición o derecho a la portabilidad de sus datos personales, escribiéndonos a la dirección de nuestras oficinas, o enviando un correo electrónico a admin@tallereslujambio.com, indicando el derecho que desea ejercer.
                </p>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Tendrá derecho igualmente a retirar el consentimiento prestado en cualquier momento. La retirada del consentimiento no afectará a la licitud del tratamiento efectuado antes de la retirada de dicho consentimiento.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Tiene derecho a presentar una reclamación ante la autoridad de control si considera que pueden haber sido vulnerados sus derechos en lo concerniente a la protección de sus datos personales.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              CLIENTES
            </h2>

            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Quién es el responsable de sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  De acuerdo con lo establecido por la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD) y el Reglamento General de Protección de Datos (RGPD) de 27 de Abril de 2016, le informamos que los datos personales aportados serán tratados por TALLERES LUJAMBIO, S.L. con CIF B20700308 y domicilio en Pol. Eziago 35, Parc 16 - 20120, Hernani (Gipuzkoa).
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Con qué finalidad tratamos sus datos personales?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Los datos aportados por usted son necesarios para poder prestarle con todas las garantías el servicio solicitado, y serán tratados con las siguientes finalidades: Gestión administrativa, contable y fiscal, gestión de las relaciones comerciales y transacciones económicas, acciones de marketing y publicidad relacionados con la empresa.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Por cuánto tiempo conservaremos sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Los datos personales proporcionados se conservarán hasta la finalización de la relación contractual y, posteriormente, durante los plazos legalmente exigidos.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Cuál es la legitimación para el tratamiento de sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  La base legal para el tratamiento de sus datos es la ejecución del contrato suscrito con nosotros.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿A qué destinatarios se comunicarán sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Para cumplir con la finalidad prevista, sus datos podrán ser comunicados a: Administración tributaria; Bancos, cajas de ahorros y cajas rurales; Administración pública con competencia en la materia.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  ¿Cuáles son sus derechos cuando nos facilita sus datos?
                </h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Cualquier persona tiene derecho a solicitar el acceso, rectificación, supresión, limitación del tratamiento, oposición o derecho a la portabilidad de sus datos personales, escribiéndonos a la dirección de nuestras oficinas, o enviando un correo electrónico a admin@tallereslujambio.com, indicando el derecho que desea ejercer.
                </p>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Tendrá derecho igualmente a retirar el consentimiento prestado en cualquier momento. La retirada del consentimiento no afectará a la licitud del tratamiento efectuado antes de la retirada de dicho consentimiento.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Tiene derecho a presentar una reclamación ante la autoridad de control si considera que pueden haber sido vulnerados sus derechos en lo concerniente a la protección de sus datos personales.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
